import styles from './confirmWarningsModal.module.css'
import { Modal } from '../modal/modal'
import { ModalId } from '../modal/types'

type Props = {
    title?: string
    warnings: string[]
    description?: string
    submitLabel?: string
    cancelLabel?: string
    onConfirm: () => void
}

// Advertencias que no bloquean: el usuario decide si continúa (ej. vender sin stock)
export const ConfirmWarningsModal = (props: Props) => {
    const { title = 'Advertencias', warnings, description, submitLabel = 'Continuar', cancelLabel, onConfirm } = props

    return (
        <Modal
            modalId={ModalId.WARNING_CONFIRM}
            title={title}
            widthSize="m"
            submitLabel={submitLabel}
            cancelLabel={cancelLabel}
            onSubmit={onConfirm}
        >
            <>
                <ul className={styles.warningList}>
                    {warnings.map((warning, index) => <li key={index}>{warning}</li>)}
                </ul>
                {description && <p className={styles.warningDescription}>{description}</p>}
                <p className={styles.warningQuestion}>¿Querés continuar de todas formas?</p>
            </>
        </Modal>
    )
}
